// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"fabde5b3","115":"5a5f5902","116":"ae52ab5b","315":"d897dec8","378":"ebbc471b","394":"46f7e229","442":"a29e572f","468":"8559af18","488":"631b293d","567":"ce6d1148","787":"e6fbcae0","795":"cf60d793","921":"7260187b","945":"eebe4014","963":"557bd0fb","971":"c08dc986"}[chunkId] + ".chunk.js";
};